import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { ValidationGroup } from 'devextreme-react';
import { isSuccess } from 'utils/responseStatus';

import { useCreateDriverPumpSalaryMutation } from 'bus/driverPumpMixerSalary/driverPumpMixerSalary';
import { DriverPumpSalaryItemCreate } from 'bus/driverPumpMixerSalary/types';

import { PumpSalaryForm } from '../../components';

type Props = {
  onRefresh: () => void;
};

const PUMP_SALARY_CREATE: DriverPumpSalaryItemCreate = {
  id: null,
  dateBegin: '',
  price: 0,
  pumpLen: 0,
  pumpQuencher: 0,
  pumpMoving: 0,
  pumpPipes: 0,
  downtime: 0,
  comment: '',
  minimalPumpDriverPrice: null,
  minimalPumpQuantity: null,
  pumpDriverOverPrice: null,
};

export const CreatePumpSalaryModal: FC<Props> = ({ onRefresh }) => {
  const { hideModal } = useModal();
  const modalValidateRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<DriverPumpSalaryItemCreate>(PUMP_SALARY_CREATE);
  const [createDriverPumpSalary] = useCreateDriverPumpSalaryMutation();

  const handleChange = (
    name: keyof DriverPumpSalaryItemCreate,
    value: DriverPumpSalaryItemCreate[keyof DriverPumpSalaryItemCreate],
  ) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const isValid = modalValidateRef.current?.instance.validate().isValid;

    if (!isValid || !form) return;

    createDriverPumpSalary(form).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
        toast.success('Запись успешно создана', {
          position: 'bottom-right',
        });
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      title="Создание настройки зарплаты насосника"
      visible
      isLoadingSubmit={false}
      width={800}
      height="auto"
      textConfirm="Создать"
      hideOnOutsideClick={false}
      onSubmit={handleSubmit}
      ref={modalValidateRef}
    >
      <PumpSalaryForm form={form} onChange={handleChange} />
    </ModalForm>
  );
};
